import Header from "./Header";
import Footer from "./Footer";
import "../../css/layout/layout.css"
import { Side, DefaultTemplateSideElements } from "./Side";
import { Outlet } from 'react-router-dom';
import { useState } from "react";

function Layout() {

    let [showSide, setShowSide] = useState(true);

    function hideAction() {
        setShowSide(!showSide);
    }

    return (
        <>
            <Side show={showSide} sideElements={<DefaultTemplateSideElements />}>
                <Header hideAction={hideAction} />
                <div className="page">
                    <div className="component">
                        <Outlet />
                    </div>
                    <Footer />
                </div>
            </Side>
       </>
    );
}

export default Layout;